module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.proset !== null) ? _c('div', {
    staticClass: "grid",
    attrs: {
      "id": "group"
    }
  }, [_c('table', {
    staticClass: "col"
  }, [_c('thead', [_c('tr', {
    staticClass: "grid"
  }, [_c('th', {
    staticClass: "col-1"
  }, [_vm._v("#")]), _vm._v(" "), _c('th', {
    staticClass: "col"
  }, [_vm._v("Name")]), _vm._v(" "), (_vm.statistic !== null) ? _c('th', {
    staticClass: "col-2"
  }, [_vm._v("Result")]) : _vm._e(), _vm._v(" "), _c('th', {
    staticClass: "col-2"
  }, [_vm._v("Deadline")])])]), _vm._v(" "), _vm._l((_vm.proitems), function(proitem) {
    return _c('tr', {
      staticClass: "grid"
    }, [_c('td', {
      staticClass: "col-1"
    }, [_vm._v(_vm._s(proitem.problem.uid))]), _vm._v(" "), _c('td', {
      staticClass: "col"
    }, [_c('router-link', {
      attrs: {
        "to": ("/problem/" + (proitem.problem.uid) + "/")
      }
    }, [_vm._v(_vm._s(proitem.problem.name))])], 1), _vm._v(" "), (_vm.statistic !== null) ? _c('td', {
      staticClass: "col-2"
    }, [_vm._v(_vm._s(_vm.getResult(proitem.problem.uid)))]) : _vm._e(), _vm._v(" "), _c('td', {
      staticClass: "col-2"
    }, [_vm._v(_vm._s(proitem.deadline ? proitem.deadline : 'None'))])])
  })], 2)]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0f3c9ba0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Group.vue
// module id = 571
// module chunks = 0